// eslint-disable-next-line import/prefer-default-export
export const COLORS = {
  PRIMARY: '#00ac94',
  BLUE: '#00cfe8',
  INDIGO: '#6610f2',
  PURPLE: '#7367f0',
  PINK: '#e83e8c',
  RED: '#ea5455',
  ORANGE: '#ff9f43',
  YELLOW: '#ffc107',
  GREEN: '#28c76f',
  TEAL: '#20c997',
  CYAN: '#17a2b8',
  WHITE: '#fff',
  GRAY: '#b8c2cc',
  GRAY_DARK: '#1e1e1e',
  LIGHT: '#f6f6f6',
  DARK: '#4b4b4b',
}

export const COLOR_VARIANTS = {
  INFO: 'info',
  LIGHT_INFO: 'light-info',
  WARNING: 'warining',
  LIGHT_WARNING: 'light-warning',
  PRIMARY: 'primary',
  LIGHT_PRIMARY: 'light-primary',
  SECONDARY: 'secondary',
  LIGHT_SECONDARY: 'light-secondary',
  OUTLINE_SECONDARY: 'outline-secondary',
  SUCCESS: 'success',
  LIGHT_SUCCESS: 'light-success',
  WHITE: 'white',
  LIGHT_DANGER: 'light-danger',
  DANGER: 'danger',
}